import { SVG } from './SVG';
const IconRestart = ({ color = '#4062bb', size = 18 }) => (
  <SVG version="1.1" viewBox="0 0 18 15.884" width={size} height={(size / 18) * 15.884} xmlns="http://www.w3.org/2000/svg">
    <path
      d="m12.396 0.86264c5.2776 1.9631 6.4514 8.9033 2.1126 12.493-4.339 3.5891-10.936 1.1352-11.875-4.4172-0.056321-0.33364-0.089695-0.67077-0.099368-1.0091"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeWidth="1.7253"
    />
    <path
      fill={color}
      d="m2.6095 7.9627c-0.28659 0-2.4536 0.038291-2.5969-0.2099-0.14329-0.24819 0.97336-2.1057 1.1167-2.3539 0.14329-0.24819 1.1936-2.144 1.4802-2.144 0.28659 0 1.3369 1.8958 1.4802 2.144 0.14329 0.24819 1.2599 2.1057 1.1167 2.3539-0.14329 0.24819-2.3103 0.2099-2.5969 0.2099z"
      fillRule="evenodd"
    />
  </SVG>
);
export { IconRestart as default, IconRestart };
